import { BizAppConfig } from 'config/application.manifest';
import { createRequest } from '@/services/request';
import type { AuthorizedResource } from '@/permissions/adapter';
import type { ApiRequestOptions } from './types/common';

const resolveTenantManagementBaseUrl = () => {
  const rawUrl = BizAppConfig.appTenantManagementUrl?.trim();
  if (!rawUrl) {
    throw new Error('未配置企业管理地址，无法获取资源权限');
  }

  return rawUrl.endsWith('/') ? rawUrl : `${rawUrl}/`;
};

const request = createRequest(resolveTenantManagementBaseUrl());

export async function getMyAuthorizedResources(
  appId: string,
  options?: ApiRequestOptions,
) {
  return request<AuthorizedResource[]>('bff/permission/me/authorized-resources', {
    method: 'GET',
    params: { appId },
    ...(options || {}),
  });
}
